export default __webpack_public_path__ + "static/media/slide-2.cf0a1d1e.jpg";